/**
 * External Imports
 */
import styled, { css } from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton, NeuCard, NeuIcon, NeuTextarea } from '@neutron/react';

interface CSSProps {
  autoWidth?: boolean | undefined;
  centered?: boolean | undefined;
}

interface IModalFooterProps {
  right?: boolean;
}

export const StoplightCard = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f6f6f6 !important;
  z-index: 10;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
  width: 28em;
`;

export const CardHeader = styled(NeuCard)`
  gap: 0;
  padding: 0 !important;
  width: 100%;
  background: white !important;
`;

export const CardMainHeader = styled.div`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding-top: var(--card-spacing);
  padding-right: var(--card-spacing);
  padding-bottom: calc(var(--card-spacing) / 2);
  padding-left: var(--card-spacing);
  height: 56px;
  width: 100%;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.9375rem;
  margin-bottom: 0.9375rem;
  min-height: 3.5em;
  position: relative;
`;

export const RadioLabelContainer = styled.div`
  margin-top: 25px;
`;

export const RadioLabel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: var(--neu-spacer-3);
  padding-bottom: var(--neu-spacer-3);
`;

export const InputHeading = styled.div<CSSProps>`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 12px;
  ${({ autoWidth }) =>
    autoWidth &&
    css`
      width: auto;
    `}
`;

export const ModalTextArea = styled(NeuTextarea)`
  margin-bottom: 0.75rem;
`;

export const ModalFooter = styled(NeuCard)<IModalFooterProps>`
  background: white !important;
  bottom: 0;
  height: 69px !important;
  padding-top: var(--card-spacing) !important;
  ${props =>
    !props.right &&
    css`
      display: flex !important;
      justify-content: space-between !important;
    `}
`;

export const InProgressIcon = styled(NeuIcon)`
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #a37318;
  margin-right: 5px;
`;

export const CompletedIcon = styled(NeuIcon)`
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #548a2c;
  margin-right: 5px;
`;

export const BlockedIcon = styled(NeuIcon)`
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #df4445;
  margin-right: 5px;
`;

export const TitleSpan = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
`;

export const TitleIcon = styled(NeuIcon)`
  margin-right: 8px;
  color: #5d99c8;
`;

export const ChipWrapper = styled.span``;

export const LabelContentBold = styled.div`
  width: 100%;
  margin-top: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #191919;
`;

export const StyledEditHeaderRow = styled.div<CSSProps>`
  display: flex;
  flex-direction: row;
  align-items: ${({ centered }) => (centered ? 'center' : 'start')};
`;

export const StyledEditHeaderCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledBoldHeading = styled(InputHeading)<CSSProps>`
  font-weight: bold;
  ${({ autoWidth }) =>
    autoWidth &&
    css`
      width: auto;
    `}
`;

export const StyledRightAlignButton = styled(NeuButton)`
  align-self: end;
`;

export const StyledCircleDoneIcon = styled(NeuIcon)`
  background-color: #548a2c;
  border-radius: 50%;
`;

export const ViewIssuesClickableLabel = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 22px;
  color: var(--primary-60);
  cursor: pointer;
`;

export const StyledDivider = styled.hr`
  width: 98%;
  margin-right: 1.5rem;
`;
